"use client";

import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { Input } from "@opensea/ui-kit";
import { bn } from "@opensea/utils";
import { useFormContext, useFormState, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { MINIMUM_OFFER_PRICE } from "../../flow/BottomSheetFlows/constants";
import { useSyncFormFields } from "../../hooks/useSyncFormField";
import { useBalances } from "../../providers/BalancesProvider";
export const OfferAmountInput = t0 => {
  const $ = _c(29);
  const {
    chain,
    autoFocus,
    warning,
    offerIndex: t1
  } = t0;
  const offerIndex = t1 === undefined ? 0 : t1;
  const t = useTranslations("wallet.OfferAmountInput");
  const {
    setValue,
    register,
    control
  } = useFormContext();
  let t2;
  if ($[0] !== control) {
    t2 = {
      control
    };
    $[0] = control;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    errors
  } = useFormState(t2);
  const {
    getOfferCurrency,
    getNativeCurrency,
    getWrappedNativeCurrency
  } = useChains();
  const offerCurrency = getOfferCurrency(chain);
  const offerSymbol = offerCurrency.symbol;
  const nativeCurrency = getNativeCurrency(chain);
  const nativeCurrencySymbol = nativeCurrency.symbol;
  const wrappedNativeCurrency = getWrappedNativeCurrency(chain);
  const {
    getBalanceOfCurrencyBySymbol
  } = useBalances();
  const balance = getBalanceOfCurrencyBySymbol({
    chainIdentifier: chain,
    symbol: offerSymbol
  });
  const nativeBalance = getBalanceOfCurrencyBySymbol({
    chainIdentifier: chain,
    symbol: nativeCurrencySymbol
  });
  const t3 = `offers.${offerIndex}.price`;
  let t4;
  if ($[2] !== control || $[3] !== t3) {
    t4 = {
      control,
      name: t3,
      defaultValue: Number.NaN
    };
    $[2] = control;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const price = useWatch(t4);
  let t5;
  if ($[5] !== price) {
    t5 = Number.isNaN(price) ? "" : price;
    $[5] = price;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const sanitizedPrice = t5;
  const t6 = `offers.${offerIndex}.shouldConfirmPrice`;
  let t7;
  if ($[7] !== control || $[8] !== t6) {
    t7 = {
      control,
      name: t6
    };
    $[7] = control;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const shouldConfirmPrice = useWatch(t7);
  const totalBalance = offerCurrency.contractAddress === wrappedNativeCurrency?.contractAddress ? bn(balance?.quantity ?? 0).plus(bn(nativeBalance?.quantity ?? 0)) : bn(balance?.quantity ?? 0);
  const t8 = `offers.${offerIndex}.tokenBalance`;
  let t9;
  if ($[10] !== t8 || $[11] !== totalBalance) {
    t9 = {
      name: t8,
      value: totalBalance
    };
    $[10] = t8;
    $[11] = totalBalance;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = `offers.${offerIndex}.currencyUsdValue`;
  const t11 = bn(balance?.currency.usdPrice ?? 0);
  let t12;
  if ($[13] !== t10 || $[14] !== t11) {
    t12 = {
      name: t10,
      value: t11
    };
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  useSyncFormFields({
    fields: [t9, {
      name: `offers.${offerIndex}.minimumOfferValueUsd`,
      value: bn(balance?.currency.chain.minOfferPriceUsd ?? 0)
    }, t12],
    setValue
  });
  let t13;
  if ($[16] !== t) {
    t13 = t("ariaLabel");
    $[16] = t;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const t14 = Boolean(errors.offers?.[offerIndex]?.price) || Boolean(shouldConfirmPrice);
  const t15 = `offers.${offerIndex}.price`;
  let t16;
  if ($[18] !== register || $[19] !== t15) {
    t16 = register(t15, {
      setValueAs: _temp
    });
    $[18] = register;
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== autoFocus || $[22] !== offerSymbol || $[23] !== sanitizedPrice || $[24] !== t13 || $[25] !== t14 || $[26] !== t16 || $[27] !== warning) {
    t17 = <Input aria-label={t13} autoFocus={autoFocus} endEnhancer={offerSymbol} error={t14} max={Number.MAX_SAFE_INTEGER} min="0" size="sm" step={MINIMUM_OFFER_PRICE} type="number" value={sanitizedPrice} warning={warning} {...t16} />;
    $[21] = autoFocus;
    $[22] = offerSymbol;
    $[23] = sanitizedPrice;
    $[24] = t13;
    $[25] = t14;
    $[26] = t16;
    $[27] = warning;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  return t17;
};
function _temp(value) {
  return value ? Number.parseFloat(value) : undefined;
}